import { useSeoMeta } from '@unhead/react';
import './Index.css';

const Index = () => {
  useSeoMeta({
    title: 'Cashu Cards — Real Cards, Real Paper, Redeemable For Real Bitcoin',
    description: 'Physical greeting cards redeemable for real sats via the Cashu protocol. Hand it to someone you love.',
  });

  return (
    <div className="cashu-page">
      {/* ============ HEADER ============ */}
      <header className="site-header">
        <a href="https://btcpay.cashucards.com/apps/2JkMFSaHrm23J6XGDJsTbRhBRDRD/pos" className="logo">
          <img src="/cashu-cards-logo.png" alt="Cashu Cards" className="logo-img" />
          <span>Buy Cashu Cards</span>
        </a>
        <div style={{ display: 'flex', gap: '12px' }}>
          <a href="https://primal.net/marc#reads" className="header-cta">Blog →</a>
          <a href="https://github.com/Marc26z/CashuCards" className="header-cta">GitHub →</a>
        </div>
      </header>

      {/* ============ HERO ============ */}
      <section className="hero">
        <div className="hero-text">
          <div className="hero-eyebrow">A greeting card with nuts redeemable for real sats inside</div>
          <h1>
            Send a Card.
            <span className="accent">Gift Bitcoin.</span>
            <span className="big-word">BRRRR.</span>
          </h1>
          <p className="hero-sub">
            Physical greeting cards redeemable for real sats via the Cashu protocol. Hand it to someone you love.
          </p>
          <div className="hero-cta-group">
            <a href="https://btcpay.cashucards.com/apps/2JkMFSaHrm23J6XGDJsTbRhBRDRD/pos" className="btn-primary">
              Buy A Cashu Card
            </a>
            <a href="#how" className="btn-secondary">↓ see how it works</a>
          </div>
        </div>

        <div className="hero-visual">
          {/* Card Front */}
          <div className="card-mock card-front card-front-photo">
            <img src="/happy-bday-card.jpg" alt="Happy ₿ Day — hand-drawn Bitcoin birthday card" className="card-photo" />
            <div className="sat-badge">⚡ 21 sats</div>
          </div>

          {/* Card Inside */}
          <div className="card-mock card-inside card-inside-photo">
            <img src="/youre-loaded-card.png" alt="BitPopArt QR code — scan to redeem sats" className="card-photo" />
          </div>

          {/* Stamps */}
          <div className="stamp stamp-1">
            ⚡ REDEEM
            <br />
            FOR
            <br />
            SATS ⚡
          </div>
          <div className="stamp stamp-2">
            HAND
            <br />
            DRAWN
            <br />
            ART
          </div>
        </div>
      </section>

      {/* ============ MARQUEE ============ */}
      <div className="marquee-strip">
        <span className="marquee-track">
          ORANGEPILL ONE BIRTHDAY CARD AT A TIME <span className="marquee-sep">✦</span>
          CASHU CARDS <span className="marquee-sep">✦</span>
          GIFT IT. <span className="marquee-sep">✦</span>
          NO AI SLOP EVER <span className="marquee-sep">✦</span>
          REDEEM FOR REAL SATS. REAL PAPER. REAL LOVE. <span className="marquee-sep">✦</span>
          ORANGE PILL ONE BIRTHDAY CARD AT A TIME <span className="marquee-sep">✦</span>
          CASHU CARDS <span className="marquee-sep">✦</span>
          GIFT IT. <span className="marquee-sep">✦</span>
          NO AI SLOP EVER <span className="marquee-sep">✦</span>
          REAL SATS. REAL PAPER. REAL LOVE. <span className="marquee-sep">✦</span>
        </span>
      </div>

      {/* ============ HOW IT WORKS ============ */}
      <section className="how-section" id="how">
        <div className="section-eyebrow">Three steps. Get A Wallet. Back Up That Wallet. Scan A QR Code.</div>
        <h2 className="section-title">How It Works</h2>
        <p className="section-sub">
          No node. No channels. No Blockchain. No 🐂💩. Just a birthday card that secretly contains sats.
        </p>

        <div className="steps-wrapper">
          <div className="steps">
            <div className="step">
              <div className="step-num">1</div>
              <span className="step-icon">🪙</span>
              <h3>Each Card Comes Loaded With 21 Sats</h3>
              <p>
                Each card contains 21 sats. Why 21 sats? According to Troy Cross,{' '}
                <b>
                  approximately 5% of people know there will never be more than 21 million whole bitcoin (technically
                  less)
                </b>
                . Is it self-custodial? No, but it is below the dust limit and it is a great way to let friends and
                family practice writing down BIP 39 words without risking the family farm.
              </p>
              <p>
                Need a Wallet? We like Minibits, but any of the wallets recommended on{' '}
                <a href="https://github.com/cashubtc/awesome-cashu?tab=readme-ov-file#wallets">Awesome Cashu</a> will
                do. They also list web wallets for app downloading resistant people.
              </p>
            </div>
            <div className="step">
              <div className="step-num">2</div>
              <span className="step-icon">🎨</span>
              <h3>Pick The Card</h3>
              <p>
                The art is hand drawn. <b>Don't give your kids AI slop</b>. Give them Cashu Cards
              </p>
            </div>
            <div className="step">
              <div className="step-num">3</div>
              <span className="step-icon">✂️</span>
              <h3>Give</h3>
              <p>
                Sign it with ink. Hand it to someone you love. Watch them blink slowly and say "...is this
                peer-to-peer electronic cash?"
              </p>
              <p>
                Just kidding...They won't say that, but you can use this card to teach them what p2p e cash is, but
                they can watch the short video on our website that teaches them how to stack nuts.
              </p>
            </div>
            <div className="step">
              <div className="step-num">4</div>
              <span className="step-icon">🎨</span>
              <h3>Guaranteed To Work Or Double Your Cashu Back</h3>
              <p>
                If you are unable to redeem the Cashu Card I will send 2 vouchers redeemable for 21 sats each.
                Scanning the Cashu for the experience is where the magic happens. Otherwise you might as well scribble{' '}
                <i>Happy Birthday</i> on a Post It Note.
              </p>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '48px' }}>
          <a href="https://btcpay.cashucards.com/apps/2JkMFSaHrm23J6XGDJsTbRhBRDRD/pos" className="btn-primary">
            Start Stacking Cashu Cards →
          </a>
        </div>
      </section>

      {/* ============ WHY ============ */}
      <section className="why-section">
        <div style={{ maxWidth: '1100px' }}>
          <div className="section-eyebrow" style={{ color: 'var(--red)' }}>
            The honest reason this exists
          </div>
          <h2 className="section-title" style={{ color: 'var(--yellow)' }}>
            Bitcoin Doesn't Need More "Bitcoin Enthusiasts". It doesn't need Astrology charts.
            <br />
            It Needs More People Stacking Sats.
          </h2>

          <div className="why-grid">
            <div className="why-copy">
              <p>
                Bitcoin has a people problem. Not a technical problem. The technical problem was solved in 2009. The
                people problem is this:{' '}
                <strong>
                  most humans on earth still think "bitcoin" is a corporation run by a some dude wearing a suit and
                  drooling over red and green candles.
                </strong>
              </p>

              <p>
                People who listen to 40 hours of bitcoin podcasts, run their own nodes, and know how to set up a Cold
                Card don't need Cashu. If you know what the acronym UTXO stands for, you don't need Cashu or Fedimint.
                Everybody else doesn't need hard core bitcoiners like us to preach about self-custody.
              </p>

              <p>
                <strong>
                  Cashu is an easy way to teach people how to use bitcoin the way it was meant to be, as p2p e cash.
                </strong>{' '}
                The people who watch candles instead of holding keys need Cashu Cards. The people who trust a memecoiner
                because he was on TV need Cashu. The people waiting for CBDC Clarity need Cashu. The people who would
                absolutely hold real bitcoin if someone they loved just stuffed it in an envelope and handed it to them
                in a birthday card need Cashu.
              </p>

              <div className="pullquote">
                "Your wife hates when you talk about bitcoin, but she'll love this card. Just kidding, but she might
                think it's cool!'"
              </div>

              <p>
                Your grandparents gave you cards with cash inside. You understood immediately.{' '}
                <strong>
                  A physical card with a QR code redeemable for sats inside is the same gesture 2.0.
                </strong>{' '}
                You don't have to explain peer-to-peer electronic cash. You just hand them a birthday card.
              </p>

              <p>
                Bitcoin adoption doesn't happen because you listen to 40 hours of bitcoin podcasts every week. It
                happens through{' '}
                <span className="underline-scribble">people using bitcoin in the real world.</span> Cashu Cards allow
                you to transfer bitcoin in the real world, one card at a time.
              </p>
            </div>

            <div className="why-sidebar">
              <h4>// Check Out This Bitcoin Dude</h4>
              <p className="anecdote">
                You're at a party. Someone tries to make small talk. You say,{' '}
                <em>
                  "Satoshi Nakamoto gave the world a protocol to deliver us from bank bailouts...{' '}
                  <i>yada, yada, yada,"</i>... They don't give a damn.
                </em>
                <br />
                <br />
                Imagine you just hand them a birthday card. They open it. There's a QR code. You say:{' '}
                <em>"scan that with a Cashu Wallet — it's real sats."</em>
                <br />
                <br />
                They scan it. Their wallet shows <em>100 sats</em>. They look at you like you pulled a rabbit out of a
                hat.
                <br />
                <br />
                <em>That's bitcoin adoption</em>, not "How's your trade going?"
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ ART ============ */}
      <section className="art-section">
        <div className="section-eyebrow">By a human. For humans.</div>
        <h2 className="section-title">The Art</h2>
        <p className="section-sub" style={{ color: 'var(--kraft-dark)' }}>
          All artwork by <strong>real people</strong> with natural intelligence.
        </p>

        <div className="no-ai-badge">
          <span>🚫</span>
          <span>Real Art. Not Slop</span>
        </div>

        <div className="art-grid">
          <div className="art-card art-card-1 art-card-photo">
            <img src="/happy-bday-card.jpg" alt="Happy ₿ Day — hand-drawn Bitcoin birthday card" className="art-card-img" />
          </div>

          <div className="art-card art-card-2 art-card-photo">
            <img src="/stack-nuts-card.png" alt="Stack Nuts — hand-drawn card" className="art-card-img" />
          </div>

          <div className="art-card art-card-3 art-card-photo">
            <img src="/happy-vday-card.jpg" alt="Happy Valentines Day — hand-drawn card with heart" className="art-card-img" />
          </div>

          <div className="art-card art-card-4 art-card-photo">
            <img src="/congrats-stack-sats.jpg" alt="Congrats. Stack Sats. — hand-drawn greeting card with confetti" className="art-card-img" />
          </div>
        </div>

        <p className="art-note">
          <strong>The art is hand-drawn</strong>.
        </p>
      </section>

      {/* ============ VIDEO ============ */}
      <section className="video-section">
        <div className="section-eyebrow" style={{ color: 'var(--yellow)' }}>
          See the whole thing in action
        </div>
        <h2 className="section-title" style={{ color: 'white' }}>
          Watch the Tutorial
        </h2>
        <p className="section-sub" style={{ color: 'rgba(255,255,255,0.7)' }}>
          Three minutes. You'll see it in action. (It's like a visual TL;DR.)
        </p>

        <div className="video-wrapper">
          {/* FIX: Changed from watch?v= URL to /embed/ URL for proper iframe embedding */}
          <iframe
            src="https://www.youtube.com/embed/XwQG2H-AutY"
            title="Cashu Cards Tutorial"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </section>

      {/* ============ FOOTER CTA ============ */}
      <section className="footer-cta">
        <h2>Make the Printer Go Brrrrrr.</h2>
        <p>
          Bitcoin adoption, one birthday card at a time. No node required. Just a printer, some glue, and someone
          worth gifting.
        </p>
        <a href="https://btcpay.cashucards.com/apps/2JkMFSaHrm23J6XGDJsTbRhBRDRD/pos" className="btn-white">
          Buy A Card ⚡
        </a>
      </section>

      {/* ============ SITE FOOTER ============ */}
      <footer className="site-footer">
        <div>
          <span
            style={{
              color: 'var(--yellow)',
              fontFamily: "'Permanent Marker', cursive",
              fontSize: '1rem',
            }}
          >
            Cashu Cards
          </span>
          <br />
          <span style={{ opacity: 0.6 }}>A handmade bitcoin experiment.</span>
        </div>
        <div style={{ textAlign: 'right', opacity: 0.7 }}>
          <a href="https://github.com/Marc26z/CashuCards/blob/main/README.md">GitHub</a>
          <br />
          Built with 🧡 by npub1marc26z8nh3xkj5rcx7ufkatvx6ueqhp5vfw9v5teq26z254renshtf3g0
          <br />
          Not financial advice | For educational purposes only | It's a greeting card | It's text | It's art | It's
          Cashu |
          <br />
          <a href="https://shakespeare.diy" style={{ opacity: 0.5, fontSize: '0.6rem' }}>
            Vibed with Shakespeare
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Index;
